import { AgendaCommercialeFilterOptionsDto, RptAgendaCommercialeDto, AgendaCommercialeSearchDto } from '@api/client';
import { createReducer } from '@reduxjs/toolkit';
import { getAgendaFilterOptions, saveFiltersAgendaActionsUsed, searchAgendaActions } from './actions';

interface InitialState {
  agendaActions: RptAgendaCommercialeDto[];
  filtersUsed: AgendaCommercialeSearchDto | undefined;
  filterOptions: AgendaCommercialeFilterOptionsDto | undefined;
  paging: {
    page: number | undefined;
    size: number | undefined;
    totalElements: number | undefined;
    totalPages: number | undefined;
  };
}

const initialState: InitialState = {
  agendaActions: [],
  filtersUsed: undefined,
  filterOptions: undefined,
  paging: {
    page: undefined,
    size: undefined,
    totalElements: undefined,
    totalPages: undefined,
  },
};

export const agendaCommercialeReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(searchAgendaActions.fulfilled, (state, action) => {
      state.agendaActions = action.payload?.content || [];
      state.paging = {
        page: action.payload?.page,
        size: action.payload?.size,
        totalElements: action.payload?.totalElements,
        totalPages: action.payload?.totalPages,
      };
    })
    .addCase(saveFiltersAgendaActionsUsed, (state, action) => {
      state.filtersUsed = action.payload;
    })
    .addCase(getAgendaFilterOptions.fulfilled, (state, action) => {
      state.filterOptions = action.payload;
    });
});
